import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

import { Layout, Form, message } from 'antd';

import TermsPolicyAPI from 'services/terms-and-policy';

import PdButton from 'components/pd-button';
import { PageSpinner } from 'components/page-spinner';

import { errHandling } from 'utils';

import './style.scss';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;

const FIELDS = {
  TERMS_AND_CONDITIONS_PATH: '',
};

export function TermsPolicyCreateEdit() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [changed, setChanged] = useState('');
  const [formLayout] = useState('vertical');
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [pageContent, setPageContent] = useState({});

  const location = window.location.pathname;
  const formItemLayout =
    formLayout === 'horizontal'
      ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 },
        }
      : null;

  useEffect(() => {
    async function getPageContentData() {
      switch (location) {
        case '/terms_and_conditions/terms':
          FIELDS.TERMS_AND_CONDITIONS_PATH = 'terms';
          setChanged('Terms and Conditions');
          break;
        case '/terms_and_conditions/rent_terms':
          FIELDS.TERMS_AND_CONDITIONS_PATH = 'rent_terms';
          setChanged('Rent Terms and Conditions');
          break;
        case '/terms_and_conditions/business_terms':
          FIELDS.TERMS_AND_CONDITIONS_PATH = 'business_terms';
          setChanged('Business Terms and Conditions');
          break;
        case '/terms_and_conditions/privacy_policy':
          FIELDS.TERMS_AND_CONDITIONS_PATH = 'privacy_policy';
          setChanged('Privacy Policy');
          break;
        default:
          FIELDS.TERMS_AND_CONDITIONS_PATH = 'terms';
          setChanged('Terms and Conditions');
          break;
      }
      const { data } = await TermsPolicyAPI.getTermCondition(
        FIELDS.TERMS_AND_CONDITIONS_PATH
      );
      const pageContentData = data.data;
      setPageContent(pageContentData);
    }

    async function getData() {
      try {
        await getPageContentData();
      } finally {
        setLoadingPage(false);
      }
    }

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSubmit(values) {
    try {
      setLoadingButton(true);

      await TermsPolicyAPI.updateTermCondition({
        ...pageContent,
        ...values,
      });
      message.success(`Successfully change ${changed}`);
      navigate({
        pathname: '/terms_and_conditions',
      });
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingButton(false);
    }
  }

  function changeValue(value, key) {
    if (value) {
      setPageContent((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    }
  }

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' },
      ],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
  ];

  if (loadingPage) {
    return <PageSpinner />;
  }

  return (
    <Content className="pageContent">
      <Form
        form={form}
        layout={formLayout}
        onFinish={handleSubmit}
        initialValues={pageContent}>
        <Layout className="pd-cms-terms-policy main-container">
          <div className="section-container">
            <div className="inner-section">
              <div className="pageTitle">{changed}</div>

              <Form.Item
                name={FIELDS.TERMS_AND_CONDITIONS_PATH}
                {...formItemLayout}>
                <ReactQuill
                  modules={modules}
                  formats={formats}
                  value={get(pageContent, FIELDS.TERMS_AND_CONDITIONS_PATH, '')}
                  onChange={(val) =>
                    changeValue(val, FIELDS.TERMS_AND_CONDITIONS_PATH)
                  }
                />
              </Form.Item>

              <Form.Item>
                <PdButton
                  full
                  type="primary"
                  htmlType="submit"
                  loading={loadingButton}>
                  Save
                </PdButton>
              </Form.Item>
            </div>
          </div>
        </Layout>
      </Form>
    </Content>
  );
}
